/* lp-countdown: the ONE countdown code every LP section shares (the D / H / M / S tiles of a sale block, the inline clock in an announcement bar).
   The clock is a tactic Brian sets per page (variant.json tactics.countdown, passed as JSON in data-config). Modes:
     fixed          ends_at, an ISO time
     resets_on_load duration_minutes after this page load, nothing stored
     daily_reset    the end of the visitor's local day
     first_view     duration_minutes from the shopper's FIRST view of any step of the offer (Brian 2026-10-04: 49 minutes on a kit page). The start
                    time lives in sessionStorage, one key per offer (`lp-countdown:<offer id>`), so a reload, or going from step 1 to step 2, keeps the
                    same remaining time. At zero it HOLDS at all zeros: the display stays up, nothing else on the page changes.
   The other modes hide the display at a past or missing end: they never count negative. Several elements on one page share one deadline (the first to
   connect sets it), so two displays always match. Formats: `tiles` (default, the sale block) and `inline` (a one-line clock for a bar: 00D 00H 49M 00S).
   An element needs data-config (the tactic JSON) and optionally data-offer (the offer id, the first_view storage key) and data-format. */
(function () {
  var shared = null;
  var pad = function (n) { return String(n).padStart(2, '0'); };

  function firstViewStart(cfg, offer) {
    var key = 'lp-countdown:' + (cfg.offer || offer || 'page'), start = null;
    try { var v = window.sessionStorage.getItem(key); if (v && !isNaN(Number(v))) start = Number(v); } catch (e) { start = null; }
    if (start === null || start > Date.now() + 60000) {  /* nothing stored (or a start in the future: a clock reset): this is the first view */
      start = Date.now();
      try { window.sessionStorage.setItem(key, String(start)); } catch (e) { /* storage blocked: this page view keeps its own clock */ }
    }
    return start;
  }

  function deadline(cfg, offer) {
    if (shared) return shared;
    var now = Date.now(), end = null, hold = false;
    if (cfg.mode === 'fixed' && cfg.ends_at) { var t = new Date(cfg.ends_at).getTime(); end = isNaN(t) ? null : t; }
    else if (cfg.mode === 'daily_reset') { var d = new Date(); d.setHours(23, 59, 59, 999); end = d.getTime(); }
    else if (cfg.mode === 'resets_on_load' && cfg.duration_minutes > 0) { end = now + cfg.duration_minutes * 60000; }
    else if (cfg.mode === 'first_view' && cfg.duration_minutes > 0) { end = firstViewStart(cfg, offer) + cfg.duration_minutes * 60000; hold = true; }
    shared = end ? { end: end, hold: hold } : { end: null, hold: false };
    return shared;
  }

  /* [days, hours, minutes, seconds] left until `end`. first_view rounds the seconds UP so a fresh session reads 00 00 49 00 and the last second reads 00. */
  function parts(end, hold) {
    var ms = Math.max(0, end - Date.now());
    var s = hold ? Math.ceil(ms / 1000) : Math.floor(ms / 1000);
    return [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60];
  }

  window.lpCountdown = { deadline: deadline, parts: parts };

  if (!customElements.get('lp-countdown-el')) customElements.define('lp-countdown-el', class extends HTMLElement {
    connectedCallback() {
      var cfg = {};
      try { cfg = JSON.parse(this.dataset.config || '{}'); } catch (e) { cfg = {}; }
      var dl = cfg.enabled === false ? { end: null, hold: false } : deadline(cfg, this.dataset.offer);
      var end = dl.end, hold = dl.hold;
      if (!end || (!hold && end <= Date.now())) { this.hidden = true; return; }
      var inline = this.dataset.format === 'inline', self = this, iv;
      var names = ['Days', 'Hours', 'Mins', 'Secs'], letters = ['D', 'H', 'M', 'S'];
      this.setAttribute('role', 'timer');
      this.innerHTML = inline
        ? letters.map(function (l, i) { return '<span class="lp-countdown__unit"><b class="lp-countdown__n" data-n>00</b><span class="lp-countdown__u" aria-label="' + names[i].toLowerCase() + '">' + l + '</span></span>'; }).join(' ')
        : names.map(function (n) { return '<span class="lp-mid-cta__tile"><b class="lp-mid-cta__tile-n" data-n>00</b><span class="lp-mid-cta__tile-l">' + n + '</span></span>'; }).join('');
      var cells = this.querySelectorAll('[data-n]');
      function tick() {
        var left = end - Date.now();
        if (left <= 0 && !hold) { clearInterval(iv); self.hidden = true; return; }
        parts(end, hold).forEach(function (x, i) { cells[i].textContent = pad(x); });
        if (left <= 0) clearInterval(iv);  /* first_view: held at all zeros */
      }
      tick();
      iv = setInterval(tick, 1000);
    }
  });
})();
